import { ProductGoToActionBlock } from "./ProductGoToActionBlock";
import { TargetAccountPlansBtn } from "../ui/buttons";

export const TargetedAccountPlansBlock = ({
  campaign_id,
}: {
  campaign_id: string;
}) => {
  return (
    <ProductGoToActionBlock
      title="Get a Tailored Account Overview for Analyzed Target Accounts"
      texts={[
        "Explore company profiles, growth strategies, and stakeholder insights across your target accounts," +
          " with detailed engagement plans and conversation guidelines designed to help you close more deals.",
      ]}
      btn={
        <TargetAccountPlansBtn isActionBlock={true} campaign_id={campaign_id} />
      }
    />
  );
};
